<template>
  <div class="transferencias-cvu-cbu">
    <base-header v-show="showHeader" type class="rsgradient pb-3 pb-1 pt-3 pt-md-5" />
    <b-card style="margin: 20px" v-show="mostrarFormulario">
      <b-card-header header-tag="header" class="p-1" role="tab">Transferir Dinero</b-card-header>

      <b-card-body>
        <!-- <div class="row form-group">
          <div class="col-md-12 text-center" style="color: #ff5855; font-weight: bolder">
            <label>¿A QUIEN DESEAS ENVIARLE DINERO?</label>
          </div>
        </div> -->

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <label>Ingresa el alias o el número de CBU/CVU</label>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Modo de transferencia</label>
            <KitsCombo
              v-model="model.modoTransferenciaID"
              v-bind:items="modosTransferencias"
              propertyName="Description"
              propertyID="EntityID"
              nullText=" -- Seleccione un modo de transferencia -- "
              :todos="false"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label v-text="inputTitle"></label>
            <base-input
              v-if="model.modoTransferenciaID == 1"
              type="number"
              v-model="model.inputValue"
              :placeholder="placeholderInput"
              style="-webkit-appearance: none;"
            ></base-input>
            <base-input
              v-if="model.modoTransferenciaID == 2"
              v-model="model.inputValue"
              :placeholder="placeholderInput"
            ></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <b-button class="btn btn-danger" @click="continuar">Continuar</b-button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <b-button
              class="btn btn-danger"
              @click="goToAgendaDestinatarios"
            >Agenda de destinatarios</b-button>
          </div>
        </div>

        <div v-for="(item,index) in contacts" @click="contactItemClicked(item)" v-bind:key="index">
          <div
            class="row"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
          >
            <div class="col-10">
              <div class="row">
                <div class="col-12 contact-item-name">
                  <span>{{item.Name}}</span>
                </div>
              </div>
              <!--  <div class="row">
                                <div class="col-12 contact-item-bank-name">
                                    <span>{{item.BankName}}</span>
                                </div>
              </div>-->
              <div class="row">
                <div class="col-12">
                  <span>{{item.CBUCVU}}</span>
                </div>
              </div>
            </div>
            <div class="col-2 text-right mt-4">&gt;</div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss">
.transferencias-cvu-cbu {
  .contact-item-name {
    color: #ff5855;
  }

  .contact-item-bank-name {
    font-weight: bolder;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsCombo from "@/components/KitsCombo";

export default {
  components: {
    KitsCombo,
    notificationHelpers
  },
  props: {
    propShowHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      model: {
        modoTransferenciaID: 1,
        inputValue: "",
        Hash: "",
        Contact: null
      },
      modosTransferencias: [],
      contacts: [],
      showHeader: this.propShowHeader,
      mostrarFormulario: false
    };
  },
  computed: {
    placeholderInput: function() {
      return this.model.modoTransferenciaID == 2
        ? "6 a 20 digitos alfanúmericos"
        : "22 digitos númericos, sin espacios ni guiones";
    },
    inputTitle: function() {
      return this.model.modoTransferenciaID == 2
        ? "Ingrese el Alias"
        : "Ingrese el CBU/CVU";
    }
  },
  beforeMount: function() {
    let context = this;
    context.GetTransferenciasCBUCVUIndex(context);
  },
  methods: {
    continuar() {
      let context = this;

      if (
        context.model.inputValue.length == undefined &&
        context.model.inputValue.length == ""
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          this.model.modoTransferenciaID == 2
            ? "El Alias no puede estar vacio"
            : "El CBU/CVU no puede estar vacio",
          context
        );
        return;
      }

      this.$validator.validate().then(valid => {
        if (valid) {
          axiosHelpers.axiosPost(
            "TransferenceContact/CheckCBUCVUAccount",
            {
              CBU:
                context.model.modoTransferenciaID == 1
                  ? context.model.inputValue
                  : "",
              Alias:
                context.model.modoTransferenciaID == 2
                  ? context.model.inputValue
                  : ""
            },
            this,
            function(data) {
              if (data.Alerts.length == 0) {
                context.model.Hash = data.ResponseVM.Hash;
                context.model.Contact = data.ResponseVM.Contact;

                context.$router.push({
                  name: "ConfirmarDatosTransferenciaCVUCBU",
                  params: {
                    destinatario: data.ResponseVM,
                    isAddContact: false,
                    buttonActionText: "Confirmar destinatario",
                    modoTransferenciaID: context.model.modoTransferenciaID,
                    inputValue: context.model.inputValue
                  }
                });
              }
            }
          );
        } else {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Verifique los campos",
            context
          );
        }
      });
    },
    goBack() {
      let context = this;
      context.$router.push("dashboard");
    },
    cancelar() {
      let context = this;
      context.$router.push(this.routeGoToAfterFinish);
    },
    goToAgendaDestinatarios() {
      let context = this;
      context.$router.push("AgendaDestinatarios");
    },
    GetTransferenciasCBUCVUIndex(context) {
      axiosHelpers.axiosGet(
        "TransferenceContact/GetTransferenciasCBUCVUIndex",
        {},
        this,
        function(data) {
          context.modosTransferencias = data.ResponseVM.TransferenceModes;
          context.contacts = data.ResponseVM.Contacts;

          context.mostrarFormulario = true;
        }
      );
    },
    contactItemClicked(contact) {
      let context = this;

      context.$router.push({
        name: "TransferAmount",
        params: {
          bankName: contact.BankName,
          alias: contact.Alias,
          cBUCVU: contact.CBUCVU,
          contactName: contact.Name,
          isAlias: contact.IsAlias,
          nameOwners: contact.NameOwners,
          cuitCuilOwners: contact.CuitCuilOwners,
          bankName: contact.BankName
        }
      });
    }
  }
};
</script>